/* SessionDetailsList.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
import React, { Children, isValidElement, type ReactNode } from 'react';
import { Inline, Text } from '@atlaskit/primitives/compiled';
const styles = {
  container: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1EqgXlN91d"
};
export type SessionDetailsListProps = {
  children: ReactNode;
  separator?: string;
  testId?: string;
};

/** An inline, separator-delimited list of composable session details. */
export const SessionDetailsList = ({
  children,
  separator = '·',
  testId
}: SessionDetailsListProps): React.JSX.Element | null => {
  const details = Children.toArray(children).filter(isValidElement);
  if (details.length === 0) {
    return null;
  }
  return <Text as="span" size="small" color="color.text.subtlest">
			<Inline as="span" grow="fill" xcss={styles.container} space="space.100" alignBlock="center" separator={separator} testId={testId}>
				{details}
			</Inline>
		</Text>;
};